import { OPEN_WINDOW, CLOSE_WINDOW, SET_MAP, SAVE_ZOOM }
    from './../actions/MapAction';

const defaultState = {
    window   : false,
    place    : false,
    mapObject: false,
    zoom     : null
};

const map = (state = defaultState, action) =>
{
    let newState;
    switch(action.type)
    {
        case OPEN_WINDOW:
            newState = {...state,
                window: action.window,
                place : action.place
            };
        break;
        case CLOSE_WINDOW:
            newState = {...state,
                window: false,
                place : false
            };
        break;
        case SET_MAP:
            newState = {...state,
                mapObject: action.mapObject
            };
        break;
        case SAVE_ZOOM:
            newState = {
                ...state,
                zoom: action.zoom
            };
            break;
        default:
            newState = state;
    }

    return newState;
};

export default map;


// WEBPACK FOOTER //
// ./src/reducers/MapReducer.js